<template>
  <div class="table-item item--shares" :class="main ? 'group-start' : ''">
    <div class="item">
      <shares-label
        v-if="item.hasManageSharedAccessPrivilege()"
        :instance="item" showAssignText
        :isIcon="isIcon"
      />
      <div v-else>-</div>
    </div>
  </div>
</template>
  
  <script>
import SharesLabel from "../../labels/SharesLabel.vue";
export default {
  components: { SharesLabel },
  props: {
    item: {
      type: Object,
    },
    main: {
      type: Boolean,
      default: false,
    },
    isIcon: Boolean,
  },
};
</script>